<template>
  <div id="app" :class="{ pcStyle: isPc, mobileStyle: isMobile, rightLayout: alignRight }">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" :key="key" />
    </keep-alive>

    <router-view v-if="!$route.meta.keepAlive" :key="key" />
    <MyToast />
    <MyLoading />
  </div>
</template>

<script>
  import ResizeMixin from '@/mixin/ResizeHandler';
  import MyToast from '@/components/MyToast/a-toast.vue';
  import MyLoading from '@/components/MyLoading/a-loading.vue';
  import { getUrlParams } from '@/utils/fns';

  export default {
    components: {
      MyToast,
      MyLoading,
    },
    mixins: [ResizeMixin],
    computed: {
      key() {
        return this.$route.fullPath;
      },
      alignRight() {
        return ['ar', 'fa', 'iw'].includes(this.$locale);
      },
    },
    created() {},
  };
</script>

<style>
</style>
